<template>
    <div class="page-close-response">
        <!-- 从其他公众号导入 -->
        <div class="sync-content-official">
            <div class="present-choose">
                <div class="choose-title">
                    {{ $t('将当前公众号') }}
                </div>
                <div class="customer-inner">
                    <img
                        :src="optionsPresent.icon"
                        class="card-img"
                    >
                    <div class="card-content">
                        <div class="card-content-text">
                            <p class="content-text-title">
                                {{ optionsPresent.name }}
                            </p>
                            <p
                                v-if="Number(optionsPresent.verifyType) !== 0"
                                class="content-text-icon"
                            >
                                <v-icon
                                    v-if="Number(optionsPresent.type) === 1"
                                    size="14"
                                    name="icon-wx-authed"
                                />
                                <v-icon
                                    v-else
                                    size="14"
                                    name="icon-authed"
                                />
                            </p>
                            <v-tag
                                color="green"
                                :text="$t('当前')"
                                size="small"
                            />
                        </div>
                        <div class="card-content-des">
                            <span>{{ Number(optionsPresent.type) == 1 ? $t('微信') : 'QQ' }}</span>
                            <span>{{ Number(optionsPresent.accountType) == 1 ? $t('订阅号') : $t('服务号') }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="official-choose">
                <div class="choose-title">
                    {{ $t('同步到以下公众号') }}
                </div>
                <div class="choose-card">
                    <v-card-picker
                        :options="optionsChoose"
                        :maps="map"
                        @select="handleOptChange"
                        multiple
                        style="width:256px"
                    >
                        <template
                            slot="item"
                            slot-scope="props"
                        >
                            <div class="customer-inner">
                                <img
                                    :src="props.item.icon"
                                    class="card-img"
                                >
                                <div class="card-content">
                                    <div class="card-content-text">
                                        <p class="content-text-title">
                                            {{ props.item.name }}
                                        </p>
                                        <p
                                            v-if="Number(props.item.verifyType) !== 0"
                                            class="content-text-icon"
                                        >
                                            <v-icon
                                                v-if="Number(props.item.type) === 1"
                                                size="14"
                                                name="icon-wx-authed"
                                            />
                                            <v-icon
                                                v-else
                                                size="14"
                                                name="icon-authed"
                                            />
                                        </p>
                                    </div>
                                    <div class="card-content-des">
                                        <span>{{ Number(props.item.type) == 1 ? $t('微信') : 'QQ' }}</span>
                                        <span>{{ Number(props.item.accountType) == 1 ? $t('订阅号') : $t('服务号') }}</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </v-card-picker>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Icon } from 'vhtml-ui';
const req = require.context('../assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);
const qqImg = '//bqq.gtimg.com/qidian/src/themes/blue/mp/account/images/QQdefault.png';
const wxImg = '//bqq.gtimg.com/qidian/src/themes/blue/mp/account/images/weixindefault.png';
export default {
    name: '',
    props: {
        title: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            optionsPresent: {},
            optionsChoose: [],
            accountID: window.data.data.accountID,
            map: {
                value: 'accountID',
            },
        };
    },
    computed: {

    },
    watch: {},
    created() {
        const { accountList, accountID, pageType } = window.data.data;
        for (let i = 0, l = accountList.length; i < l; i++) {
            if (Number(accountList[i].accountID) !== Number(accountID)) {
                //  qq未认证账号 可以进行自动回复操作和菜单设置。微信未认证账号，不支持菜单设置，但自动回复可以操作
                if (Number(pageType) === 1
                    || (Number(pageType) === 0 && (Number(accountList[i].type) === 2
                            || (Number(accountList[i].type) === 1
                                && !(Number(accountList[i].accountType) === 1
                                    && Number(accountList[i].verifyType) === 0)
                            ))
                    )
                ) {
                    this.optionsChoose.push({
                        accountID: accountList[i].accountID,
                        name: accountList[i].name,
                        type: accountList[i].type,
                        accountType: accountList[i].accountType,
                        verifyType: accountList[i].verifyType,
                        // eslint-disable-next-line no-nested-ternary
                        icon: accountList[i].icon
                            ? accountList[i].icon : (Number(accountList[i].type) === 1 ? wxImg : qqImg),
                    });
                }
            } else {
                // 如果是当前公众号
                this.optionsPresent =  {
                    accountID: accountList[i].accountID,
                    name: accountList[i].name,
                    type: accountList[i].type,
                    accountType: accountList[i].accountType,
                    verifyType: accountList[i].verifyType,
                    // eslint-disable-next-line no-nested-ternary
                    icon: accountList[i].icon
                        ? accountList[i].icon : (Number(accountList[i].type) === 1 ? wxImg : qqImg),
                };
            }
        }
    },
    methods: {
        // 选择公众号
        handleOptChange(val) {
            this.$emit('change', val);
        },
    },
};
</script>

<style lang="less" scoped>
.sync-content-official {
        display: flex;
        align-items: start;
        .official-choose {
            border-left: 1px solid var(--color-divider-normal);
            padding-left: var(--spacing-loose);
            .choose-card {
                max-height: 250px;
                overflow-y: auto;
                overflow-x: hidden;
                .customer-inner {
                    display: flex;
                    img {
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                    }
                    .card-content {
                        text-align: left;
                        margin-left: var(--spacing-base-loose);
                        .card-content-text {
                            display: flex;
                            .content-text-title {
                                max-width: 160px;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                overflow: hidden;
                            }
                            .content-text-icon {
                                height: 14px;
                                margin: 1px 3px 0;
                            }
                        }
                        .card-content-des {
                            color: var(--color-text-caption);
                            font-size: 12px;
                        }
                    }
                }
            }
        }
        .present-choose {
            padding-right: var(--spacing-loose);
            .customer-inner {
                border: var(--border-normal) solid var(--color-border-normal);
                width: 230px;
                height: 40px;
                display: flex;
                align-items: center;
                padding: var(--spacing-base-loose);
                img {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                }
                 .card-content {
                        text-align: left;
                        margin-left: var(--spacing-base-loose);
                        .card-content-text {
                            display: flex;
                            .content-text-title {
                                max-width: 120px;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                overflow: hidden;
                            }
                            .content-text-icon {
                                height: 14px;
                                margin: 1px 3px 0;
                            }
                        }
                        .card-content-des {
                            color: var(--color-text-caption);
                            font-size: 12px;
                        }
                    }
            }
        }
        .choose-title {
                color: var(--color-text-caption);
                text-align: left;
                margin-bottom: 10px;
            }
    }
</style>
<style lang="less">
    .sync-content-official {
        .choose-card {
            .v-card-picker {
                .v-card-picker__item {
                    width: 256px;
                }
            }
        }
    }
</style>

